import styled from 'styled-components';
import { Image } from '~/components/wrappers/Image';
import PoundWhite from 'public/assets/icons/pound_white.svg';
import PoundBlack from 'public/assets/icons/pound_black.svg';
import Pound from 'public/assets/icons/pound.svg';
import { getCurrencySymbol } from '~/common/utils/currency';
import { fontFamilies } from '~/theme/typography';

const VARIANT_COLORS = {
  white: '#fff',
  black: '#000',
  default: '#fff',
} as const;

type CurrencyVariant = keyof typeof VARIANT_COLORS;

const ICONS: Record<string, Record<CurrencyVariant, string>> = {
  GBP: { white: PoundWhite, black: PoundBlack, default: Pound },
};

interface CurrencyIconProps {
  currencyCode?: string;
  variant?: CurrencyVariant;
  className?: string;
  textStyles?: ITextStyles;
}

interface ITextStyles {
  fontSize?: string;
}

const CurrencyIcon = ({
  currencyCode = 'GBP',
  variant = 'white',
  className,
  textStyles,
}: CurrencyIconProps) => {
  const icons = ICONS[currencyCode];

  if (icons) {
    return (
      <Image
        src={icons[variant]}
        alt={getCurrencySymbol(currencyCode)}
        className={className}
      />
    );
  }

  return (
    <TextSymbol
      className={className}
      $variant={variant}
      $textStyles={textStyles}
    >
      {getCurrencySymbol(currencyCode)}
    </TextSymbol>
  );
};

export default CurrencyIcon;

const TextSymbol = styled.span<{
  $variant: CurrencyVariant;
  $textStyles?: ITextStyles;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${fontFamilies.PantonRustHeavy};
  font-size: ${({ $textStyles }) => $textStyles?.fontSize ?? 'inherit'};
  font-weight: 100;
  line-height: 1;
  color: ${({ $variant }) => VARIANT_COLORS[$variant]};
`;
